import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { loginAdmin, logoutAdmin } from "../services/api";

export const login = createAsyncThunk(
  "auth/login",
  async ({ email, password }, { rejectWithValue }) => {
    try {
      const response = await loginAdmin(email, password);
      await sessionStorage.setItem("email", email);
      await sessionStorage.setItem("profileImage", response.profileImageUrl);

      await sessionStorage.setItem("password", password);
      await sessionStorage.setItem("id", response.id);
      await sessionStorage.setItem("accessToken", response.accessToken);
      return response;
    } catch (error) {
      console.error("Login error:", error);
      return rejectWithValue(error.response.data);
    }
  }
);

export const logout = createAsyncThunk("auth/logout", async () => {
  try {
    const response = await logoutAdmin();
    sessionStorage.removeItem("accessToken");
    sessionStorage.removeItem("email");
    sessionStorage.removeItem("profileImage");
    sessionStorage.removeItem("id");
    return response;
  } catch (error) {
    console.error("Logout error:", error);
    throw error;
  }
});

const authSlice = createSlice({
  name: "auth",
  initialState: {
    user: null,
    isAuthenticated: !!sessionStorage.getItem("accessToken"),
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload;
        state.isAuthenticated = true;
      })
      .addCase(login.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(logout.fulfilled, (state) => {
        state.user = null;
        state.isAuthenticated = false;
      });
  },
});

export default authSlice.reducer;
